module.exports = __webpack_public_path__ + "static/media/teen.4e255f53.svg";